export enum ApiError {
   SuiteEmailDuplicate = 'error.constraint.error.email.email_exists_for_building_and_suite'
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/errors.ts